package com.fantasytenis.shared.data.notifications.api

import com.fantasytenis.shared.data.notifications.dto.NotificationsResponseDto
import com.fantasytenis.shared.data.notifications.dto.NotificationResponseDto
import com.fantasytenis.shared.data.notifications.dto.UnreadCountResponseDto
import com.fantasytenis.shared.data.notifications.dto.NotificationSuccessResponseDto
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*

/**
 * API client for notification endpoints.
 */
class NotificationsApi(
    private val httpClient: HttpClient,
    private val baseUrl: String
) {
    /**
     * Get user's notifications with pagination.
     * GET /v2/notifications?limit=20&offset=0&unreadOnly=false
     */
    suspend fun getNotifications(
        limit: Int = 20,
        offset: Int = 0,
        unreadOnly: Boolean = false
    ): NotificationsResponseDto {
        return httpClient.get("${baseUrl}notifications") {
            parameter("limit", limit)
            parameter("offset", offset)
            parameter("unreadOnly", unreadOnly)
        }.body()
    }

    /**
     * Get unread notification count.
     * GET /v2/notifications/unread-count
     */
    suspend fun getUnreadCount(): UnreadCountResponseDto {
        return httpClient.get("${baseUrl}notifications/unread-count").body()
    }

    /**
     * Mark a notification as read.
     * PATCH /v2/notifications/:id/read
     */
    suspend fun markAsRead(notificationId: String): NotificationSuccessResponseDto {
        return httpClient.patch("${baseUrl}notifications/$notificationId/read").body()
    }

    /**
     * Mark all notifications as read.
     * POST /v2/notifications/read-all
     */
    suspend fun markAllAsRead(): NotificationSuccessResponseDto {
        return httpClient.post("${baseUrl}notifications/read-all").body()
    }

    /**
     * Delete a notification.
     * DELETE /v2/notifications/:id
     */
    suspend fun deleteNotification(notificationId: String): NotificationSuccessResponseDto {
        return httpClient.delete("${baseUrl}notifications/$notificationId").body()
    }
}
